/**
 * Utility functions for handling image URLs
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

/**
 * Get the full URL for a profile picture
 * @param {string} profilePictureUrl - The relative profile picture URL from the database
 * @returns {string|null} - The full URL or null if no URL provided
 */
export const getProfilePictureUrl = (profilePictureUrl) => {
  if (!profilePictureUrl) {
    return null;
  }

  // If it's already an absolute URL, return as is
  if (profilePictureUrl.startsWith('http://') || profilePictureUrl.startsWith('https://')) {
    return profilePictureUrl;
  }

  // Get the base URL without the /api suffix
  const baseUrl = API_BASE_URL.replace('/api', '');

  // If it starts with /api/, use the base URL
  if (profilePictureUrl.startsWith('/api/')) {
    return `${baseUrl}${profilePictureUrl}`;
  }

  // If it's a relative path starting with /uploads/, prepend base URL
  if (profilePictureUrl.startsWith('/uploads/')) {
    return `${baseUrl}${profilePictureUrl}`;
  }

  // If it doesn't start with /, add it as a relative path to uploads
  if (!profilePictureUrl.startsWith('/')) {
    return `${baseUrl}/uploads/profile-pictures/${profilePictureUrl}`;
  }

  // Default case: prepend the base URL
  return `${baseUrl}${profilePictureUrl}`;
};

/**
 * Get the full URL for any uploaded image (generic version)
 * @param {string} imageUrl - The relative image URL from the database
 * @returns {string|null} - The full URL or null if no URL provided
 */
export const getUploadedImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return null;
  }

  // If it's already an absolute URL, return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // Get the base URL without the /api suffix
  const baseUrl = API_BASE_URL.replace('/api', '');

  // If it's a relative path starting with /, prepend base URL
  if (imageUrl.startsWith('/')) {
    return `${baseUrl}${imageUrl}`;
  }

  // Default case: prepend the base URL with /
  return `${baseUrl}/${imageUrl}`;
};